import { useSelector } from 'react-redux';
import React, { FC } from 'react';
import { selectMediaWidth } from '../../../store/slices/media-query.slice';

type mediaBreakPoints = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'hd' | 'uw';
const mediaMap = new Map<mediaBreakPoints | undefined, number>();
mediaMap.set('xs', 375);
mediaMap.set('sm', 640);
mediaMap.set('md', 768);
mediaMap.set('lg', 992);
mediaMap.set('xl', 1200);
mediaMap.set('xxl', 1440);
mediaMap.set('hd', 1800);
mediaMap.set('uw', 2200);

interface MediaWidthProps {
    min?: mediaBreakPoints;
    max?: mediaBreakPoints;
    children?: React.ReactNode;
}

export const MediaWidth: FC<MediaWidthProps> = props => {
    const mediaWidthState = useSelector(selectMediaWidth);
    const min = mediaMap.get(props.min);
    const max = mediaMap.get(props.max);
    const satisfiesMin = min ? min < mediaWidthState : true;
    const satisfiesMax = max ? mediaWidthState <= max : true;
    if (satisfiesMin && satisfiesMax) return <>{props.children}</>;
    return <></>;
};
